import React from 'react'
import { ModalDialog, Button } from 'components'
import styled, { css } from 'styled-components'
import { FaTrashAlt } from 'react-icons/fa'

export const buttonStyle = css`
  background-color: ${({ theme }) => theme.palette.danger[0]} !important;
  border-color: ${({ theme }) => theme.palette.danger[2]} !important;
  box-shadow: none;
`

export const Modal = ({ className, children, ...rest }) => (
  <ModalDialog className={className} {...rest}>
    {children}
  </ModalDialog>
)

export const Container = styled(Modal)`
  .modal-content {
    padding: 1rem 2rem;
  }

  .modal-footer {
    > button {
      font-size: 0.9rem;
      min-height: 2.5rem;
    }
  }

  .form-check-input {
    margin-top: 0.2rem;
  }
`

export const Trash = styled(FaTrashAlt)`
  color: ${({ theme }) => theme.palette.danger[0]};
  font-size: 2rem;
`

export const Content = styled.div`
  color: ${({ theme }) => theme.palette.grayscale[1]};
  padding: 0.5rem 1rem;

  ${Trash} {
    position: absolute;
    right: 1rem;
  }
`

export const ConfirmButton = styled(Button)`
  ${buttonStyle}

  &:active, &:focus, &:hover {
    ${buttonStyle}
  }
`
